import React from 'react'
import { BoxProps as MUIBoxProps } from '@mui/material/Box'
import { Box as MUIBox } from '@mui/material'

export interface CopyContainerProps extends MUIBoxProps {
  padding?:
    | '0'
    | 'xsmall'
    | 'small'
    | 'medium'
    | 'large'
    | 'xlarge'
    | {
        top?: '0' | 'xsmall' | 'small' | 'medium' | 'large' | 'xlarge'
        right?: '0' | 'xsmall' | 'small' | 'medium' | 'large' | 'xlarge'
        bottom?: '0' | 'xsmall' | 'small' | 'medium' | 'large' | 'xlarge'
        left?: '0' | 'xsmall' | 'small' | 'medium' | 'large' | 'xlarge'
      }
  topBottom?: boolean
  leftRight?: boolean
  noRightMargin?: boolean
  bgColor?: string // optional background color
  overflowHidden?: boolean
}

const paddingSizes = {
  ['0']: 0,
  xsmall: 2,
  small: 5,
  medium: 7,
  large: 10,
  xlarge: 20,
}

const CopyContainer: React.FC<CopyContainerProps> = ({
  padding: paddingProp = '0',
  topBottom,
  leftRight,
  noRightMargin = false,
  marginTop,
  overflowHidden = true,
  bgColor = 'transparent',
  children,
  sx,
  ...props
}) => {
  let padding = {
    paddingTop: 0,
    paddingRight: 0,
    paddingBottom: 0,
    paddingLeft: 0,
  }

  if (typeof paddingProp === 'string') {
    if (leftRight) {
      padding.paddingRight = paddingSizes[paddingProp]
      padding.paddingLeft = paddingSizes[paddingProp]
    } else if (topBottom) {
      padding.paddingTop = paddingSizes[paddingProp]
      padding.paddingBottom = paddingSizes[paddingProp]
    } else {
      padding.paddingTop = paddingSizes[paddingProp]
      padding.paddingRight = paddingSizes[paddingProp]
      padding.paddingBottom = paddingSizes[paddingProp]
      padding.paddingLeft = paddingSizes[paddingProp]
    }
  } else {
    padding = {
      paddingTop: paddingProp?.top
        ? paddingSizes[paddingProp.top]
        : padding.paddingTop,
      paddingRight: paddingProp?.right
        ? paddingSizes[paddingProp.right]
        : padding.paddingRight,
      paddingBottom: paddingProp?.bottom
        ? paddingSizes[paddingProp.bottom]
        : padding.paddingBottom,
      paddingLeft: paddingProp?.left
        ? paddingSizes[paddingProp.left]
        : padding.paddingLeft,
    }
  }

  if (noRightMargin) {
    padding.paddingRight = 0
  }

  return (
    <MUIBox
      sx={{
        ...padding,
        bgcolor: bgColor,
        width: '100%',
        boxSizing: 'border-box',
        overflow: overflowHidden ? 'hidden' : 'visible',
        ...sx,
      }}
      {...props}
    >
      {children}
    </MUIBox>
  )
}

export default CopyContainer
